const appConfig = {
  url: {
    app: {
      skill: process.env.VUE_APP_SKILL_APP_BASE_URL
    }
  },
  auth: {
    retry: {
      limit: 10
    }
  }
};

export default appConfig;
